export const coordinatesMap = [
  {
    value: 'External Party',
    coordinates: {
      x: 410,
      y: 310
    }
  },
  {
    value: 'GOM',
    coordinates: {
      x: 550,
      y: 130
    }
  },
  {
    value: 'Internal Party',
    coordinates: {
      x: 470,
      y: 120
    }
  },
  {
    value: 'NAPE',
    coordinates: {
      x: 610,
      y: 280
    }
  },
  {
    value: 'Snowflake',
    coordinates: {
      x: 250,
      y: 50
    }
  },
  {
    value: 'STRIPES',
    coordinates: {
      x: 150,
      y: 190
    }
  },
  {
    value: 'ADS',
    coordinates: {
      x: 90,
      y: 90
    }
  },
  {
    value: 'CCDS',
    coordinates: {
      x: 30,
      y: 250
    }
  },
  {
    value: 'CDS',
    coordinates: {
      x: 240,
      y: 125
    }
  },
  {
    value: 'DDS',
    coordinates: {
      x: 300,
      y: 310
    }
  },
  {
    value: 'DisDS',
    coordinates: {
      x: 540,
      y: 260
    }
  },
  {
    value: 'DocDS',
    coordinates: {
      x: 530,
      y: 50
    }
  },
  {
    value: 'EDS',
    coordinates: {
      x: 520,
      y: 310
    }
  },
  {
    value: 'FDN',
    coordinates: {
      x: 35,
      y: 140
    }
  },
  {
    value: 'IDS',
    coordinates: {
      x: 440,
      y: 180
    }
  },
  {
    value: 'InDS',
    coordinates: {
      x: 175,
      y: 100
    }
  },
  {
    value: 'LCDS',
    coordinates: {
      x: 580,
      y: 200
    }
  },
  {
    value: 'LDS',
    coordinates: {
      x: 350,
      y: 50
    }
  },
  {
    value: 'MatDS',
    coordinates: {
      x: 280,
      y: 225
    }
  },
  {
    value: 'MvtDS',
    coordinates: {
      x: 610,
      y: 100
    }
  },
  {
    value: 'PDS',
    coordinates: {
      x: 435,
      y: 235
    }
  },
  {
    value: 'PTDS',
    coordinates: {
      x: 210,
      y: 310
    }
  },
  {
    value: 'SCDS',
    coordinates: {
      x: 350,
      y: 180
    }
  },
  {
    value: 'SPlDS',
    coordinates: {
      x: 430,
      y: 45
    }
  },
  {
    value: 'ODS',
    coordinates: {
      x: 110,
      y: 290
    }
  },
  {
    value: 'TDS',
    coordinates: {
      x: 20,
      y: 195
    }
  }
];
